// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import BusComponent from '../BusComponent';
import LocationAnalysisReportButton from './LocationAnalysisReportButton';
/**
 * @typedef Props
 * @property {string} mapInstanceId
 * @property {Array.<import('../../types').FeaturedSurveyReport | import('../../types').FeaturedOlapReport>} reports
 * @property {boolean} isUserStarterTier
 * @property {import('react-intl').intlShape} intl
 *
 * @extends {BusComponent<Props>}
 */
class LocationAnalysisReports extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            customizationDetailsForStorageReport: {},
        };
        this.bindGluBusEvents({
            GET_CURRENT_CUSTOMIZATION_DETAILS: this.onGetCurrentCustomizationDetails,
            APPLY_POINTS_FILTERS_REQUEST: this.onFiltersChanged,
            POINTS_GEOJSON: this.onPointsGeoJsonLoaded,
            GET_STORAGE_FACILITY_COUNT_SUCCESS: this.onFacilityCountLoaded,
        });
    }

    refreshFacilityCount = () => {
        this.bus.emit('MAP_CURRENT_FILTERS_TO_CUSTOMIZATION_DETAILS', {
            mapInstanceId: this.props.mapInstanceId,
        });
        this.bus.emit('GET_STORAGE_FACILITY_COUNT_REQUEST', {
            mapInstanceId: this.props.mapInstanceId,
        });
    };

    componentDidMount() {
        this.refreshFacilityCount();
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mapInstanceId !== this.props.mapInstanceId) {
            this.refreshFacilityCount();
        }
    }

    onFacilityCountLoaded = ({ facilityCount }) => {
        this.setState({ facilityCount });
    };

    // Re-emit when GeoJson loads (handles case where component mounts before GeoJson is ready)
    onPointsGeoJsonLoaded = () => {
        this.refreshFacilityCount();
    };

    onGetCurrentCustomizationDetails = e => {
        this.setState({
            customizationDetailsForStorageReport: e.customizationDetails,
            facilityCount: e.facilityCount,
        });
    };

    onFiltersChanged = () => {
        this.refreshFacilityCount();
    };

    render() {
        const { reports, isUserStarterTier, mapInstanceId } = this.props;
        const { customizationDetailsForStorageReport, facilityCount } = this.state;

        return (
            <div>
                {reports.map((report, idx) => (
                    <div className="report-popup__download-btn" key={report.name}>
                        <LocationAnalysisReportButton
                            report={report}
                            mapInstanceId={mapInstanceId}
                            isUserStarterTier={isUserStarterTier}
                            customizationDetailsForStorageReport={
                                customizationDetailsForStorageReport
                            }
                            facilityCount={facilityCount}
                        />
                        {idx < reports.length - 1 && <div className="report-popup__divider" />}
                    </div>
                ))}
            </div>
        );
    }
}

LocationAnalysisReports.propTypes = {
    mapInstanceId: PropTypes.string.isRequired,
    reports: PropTypes.array.isRequired,
    isUserStarterTier: PropTypes.bool.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(LocationAnalysisReports);
